/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component } from "@angular/core";

@Component({
	selector: "globalictcc-work-in-progress",
	standalone: true,
	imports: [],
	templateUrl: "./work-in-progress.component.html",
	styleUrl: "./work-in-progress.component.scss"
})
export class WorkInProgressComponent {}
